module.exports = __webpack_public_path__ + "static/img/rank_99.3a6c22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_99.png
// module id = Mfh8
// module chunks = 1